import _objectSpread from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["faction"],
  _excluded2 = ["value"],
  _excluded3 = ["sections", "Icon", "size", "iconSize", "label", "showSeparator", "showStartBar", "glowSize", "startBarHeight", "startBarWidth", "startBarColor", "borderSize", "backgroundColor", "thickness", "extra", "styles", "className", "classNames", "fillColor", "unstyled"];
import { jsx, jsxs } from 'react/jsx-runtime';
import { RingProgress, Stack } from '@mantine/core';
import { forwardRef } from 'react';
import { FindFactionColor } from '../FactionColors.js';
import useStyles from './WarzoneProgressRound.styles.js';
import { FWSupport } from '../../logos/factionalwarfare/FWSupport.js';
var sectionConvert = function sectionConvert(_ref) {
  var faction = _ref.faction,
    rest = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread({
    color: FindFactionColor(faction != null ? faction : "neutral", {
      neutral: "dimmed"
    })
  }, rest);
};
var insertSeparators = function insertSeparators(sections, separatorThickness, className) {
  if (sections.some(function (_ref2) {
    var value = _ref2.value;
    return value > 100 - separatorThickness;
  })) {
    return sections;
  }
  return sections.reduce(function (obj, _ref3, i) {
    var value = _ref3.value,
      section = _objectWithoutProperties(_ref3, _excluded2);
    if (i > 0) {
      obj.push({
        value: separatorThickness,
        color: "#transparent",
        className: className
      });
      value = Math.max(value - separatorThickness, 0);
    }
    obj.push(_objectSpread({
      value: value
    }, section));
    return obj;
  }, []);
};
var WarzoneProgressRound = forwardRef(function (_ref4, ref) {
  var _ref4$sections = _ref4.sections,
    sections = _ref4$sections === void 0 ? [] : _ref4$sections,
    _ref4$Icon = _ref4.Icon,
    Icon = _ref4$Icon === void 0 ? FWSupport : _ref4$Icon,
    _ref4$size = _ref4.size,
    size = _ref4$size === void 0 ? 128 : _ref4$size,
    _ref4$iconSize = _ref4.iconSize,
    iconSize = _ref4$iconSize === void 0 ? 48 : _ref4$iconSize,
    _ref4$label = _ref4.label,
    label = _ref4$label === void 0 ? "" : _ref4$label,
    _ref4$showSeparator = _ref4.showSeparator,
    showSeparator = _ref4$showSeparator === void 0 ? false : _ref4$showSeparator,
    _ref4$showStartBar = _ref4.showStartBar,
    showStartBar = _ref4$showStartBar === void 0 ? false : _ref4$showStartBar,
    _ref4$glowSize = _ref4.glowSize,
    glowSize = _ref4$glowSize === void 0 ? 0 : _ref4$glowSize,
    _ref4$startBarHeight = _ref4.startBarHeight,
    startBarHeight = _ref4$startBarHeight === void 0 ? 35 : _ref4$startBarHeight,
    _ref4$startBarWidth = _ref4.startBarWidth,
    startBarWidth = _ref4$startBarWidth === void 0 ? 1.5 : _ref4$startBarWidth,
    _ref4$startBarColor = _ref4.startBarColor,
    startBarColor = _ref4$startBarColor === void 0 ? "#D9D9D9" : _ref4$startBarColor,
    borderSize = _ref4.borderSize,
    backgroundColor = _ref4.backgroundColor,
    _ref4$thickness = _ref4.thickness,
    thickness = _ref4$thickness === void 0 ? 8 : _ref4$thickness,
    extra = _ref4.extra,
    styles = _ref4.styles,
    className = _ref4.className,
    classNames = _ref4.classNames,
    _ref4$fillColor = _ref4.fillColor,
    fillColor = _ref4$fillColor === void 0 ? void 0 : _ref4$fillColor,
    unstyled = _ref4.unstyled,
    rest = _objectWithoutProperties(_ref4, _excluded3);
  var _useStyles = useStyles({
      startBarHeight: startBarHeight,
      startBarWidth: startBarWidth,
      thickness: thickness,
      startBarColor: startBarColor,
      glowSize: glowSize,
      backgroundColor: backgroundColor,
      borderSize: borderSize
    }, {
      name: "WarzoneProgressRound",
      classNames: classNames,
      styles: styles,
      unstyled: unstyled
    }),
    classes = _useStyles.classes,
    cx = _useStyles.cx;
  var mappedSections = sections && Array.isArray(sections) ? sections.map(sectionConvert) : [];
  var renderSections = showSeparator ? insertSeparators(mappedSections, 0.5, classes.separator) : mappedSections;
  if (fillColor) {
    var remaining = 100 - renderSections.reduce(function (sum, _ref5) {
      var value = _ref5.value;
      return sum + value;
    }, 0);
    if (remaining > 0) {
      renderSections.push({
        value: remaining,
        color: fillColor
      });
    }
  }
  return /* @__PURE__ */jsx(RingProgress, _objectSpread(_objectSpread({
    ref: ref,
    size: size,
    thickness: thickness,
    className: cx(classes.root, showStartBar ? classes.withStartBar : "", className),
    label: /* @__PURE__ */jsxs(Stack, {
      spacing: 0,
      align: "center",
      children: [/* @__PURE__ */jsx(Icon, {
        size: iconSize
      }), label]
    }),
    sections: renderSections
  }, rest), {}, {
    styles: styles,
    classNames: classNames,
    unstyled: unstyled
  }));
});
WarzoneProgressRound.displayName = "WarzoneProgressRound";
export { WarzoneProgressRound };